/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import {
  IDepartament,
  IDistrict,
  IProvince,
  IBranchStoreUpdate,
  IBranchStoreTable,
  BRANCH_STORE_TTL_ES
} from '../../../branch-store.interface';
import { FormBuilder, Validators } from '@angular/forms';
import { BranchStoreService } from '../../../branch-store.service';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-branch-store-update',
  templateUrl: './branch-store-update.component.html'
})
export class BranchStoreUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  departments: IDepartament[];
  provinces: IProvince[];
  districts: IDistrict[];

  constructor(
    private fb: FormBuilder,
    private serviceBase: BranchStoreService
  ) {
    super(BRANCH_STORE_TTL_ES, serviceBase);
  }

  ngOnInit(): void {
    const item = this.row as IBranchStoreTable;
    this.departments = this.serviceBase.getDepartaments();
    this.provinces = this.serviceBase.getProvinces(item.departmentId);
    this.districts = this.serviceBase.getDistricts(item.provinceId);

    this.fg = this.fb.group({
      name: [
        item.name,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      address: [
        item.address,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      establishmentCode: [
        item.establishmentCode,
        [Validators.required, Validators.minLength(2), Validators.maxLength(32)]
      ],
      departmentId: [item.departmentId, [Validators.required]],
      provinceId: [item.provinceId, [Validators.required]],
      districtId: [item.districtId, [Validators.required]]
    });
  }

  onSubmit() {
    this.updateItem$(this.fg.value as IBranchStoreUpdate);
  }

  filterProvinces(departmentId) {
    this.fg.get('provinceId').reset();
    this.fg.get('districtId').reset();
    this.provinces = this.serviceBase.getProvinces(departmentId);
    this.districts = [];
  }

  filterDistricts(provinceId) {
    this.fg.get('districtId').reset();
    this.districts = this.serviceBase.getDistricts(provinceId);
  }
}
